import { startsWithHttp } from "@luma-team/shared";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import qs from "query-string";
import React, { DOMAttributes } from "react";

import { useComponentsOverrides } from "./ComponentsOverridesContext";
import { ExternalLink } from "./ExternalLink";

export const LuxLink = React.forwardRef(
  (
    {
      className: _className,
      onClick,
      href,
      children,
      query,
      openInNewTab,
      forcePageChange,
      disabled,
      ...props
    }: {
      className?: string;
      onClick?: DOMAttributes<HTMLAnchorElement>["onClick"];
      href: string;
      children: React.ReactNode;
      query?: { [key: string]: string | boolean | undefined };
      openInNewTab?: boolean;
      forcePageChange?: boolean;
      disabled?: boolean;
    } & React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >,
    ref: React.ForwardedRef<HTMLAnchorElement>,
  ) => {
    const { Link, HOST } = useComponentsOverrides();

    if (href.startsWith(HOST)) {
      href = href.slice(HOST.length);
    }

    if (query && !isEmpty(query)) {
      href += "?" + qs.stringify(query);
    }

    const className = classNames(_className, { disabled });

    if (startsWithHttp(href)) {
      return (
        <ExternalLink
          {...props}
          ref={ref}
          openInNewTab={openInNewTab}
          href={href}
          className={className}
          onClick={onClick}
        >
          {children}
        </ExternalLink>
      );
    }

    if (openInNewTab || forcePageChange) {
      return (
        <a
          {...props}
          ref={ref}
          href={href}
          target={openInNewTab ? "_blank" : "_self"}
          className={className}
          onClick={onClick}
        >
          {children}
        </a>
      );
    }

    return (
      <Link
        href={href}
        {...props}
        ref={ref}
        className={className}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  },
);
